import { Axios } from "../utils/axios";

// 获取列表
export const getList = params => {
  return Axios.get("/trainAdmin/questionPracticalPaper/list", { params });
};
// 新增;
export const createInfo = data => {
  console.log(data);
  return Axios.post("/trainAdmin/questionPracticalPaper", data);
};
// 编辑
export const editInfo = data => {
  console.log(data);
  return Axios.put("/trainAdmin/questionPracticalPaper", data);
};
// 删除;
export const deleteInfo = id => {
  return Axios.delete(`/trainAdmin/questionPracticalPaper/${id}`);
};
// 单条信息;
export const getInfo = id => {
  return Axios.get(`/trainAdmin/questionPracticalPaper/${id}`);
};

// 关联试题
// 获取列表
export const getQuestionList = params => {
  return Axios.get("/trainAdmin/questionPracticalPaperDetail/list", { params });
};
// 新增;
export const createQuestionInfo = data => {
  return Axios.post("/trainAdmin/questionPracticalPaperDetail", data);
};
// 编辑
export const editQuestionInfo = data => {
  return Axios.put("/trainAdmin/questionPracticalPaperDetail", data);
};
// 删除;
export const deleteQuestionInfo = id => {
  return Axios.delete(`/trainAdmin/questionPracticalPaperDetail/${id}`);
};

export const queryInfo = params => {
  return Axios.get(`/trainAdmin/questionPracticalPaperDetail/queryInfo`, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/handsOnPaper.js